import { FaUserMinus, FaUserPlus } from "react-icons/fa";

import styled from "styled-components";
import { useStoreWrapper } from "../../store/store";
import AlertDialog from "../../screens/User/Users/components/AlertDialog/AlertDialog";
import { useState } from "react";
import Button from "../Button";
import useUser from "../../screens/User/hooks/useUser";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const Container = styled.span`
  z-index: 10099;
`;
const MakeUserActiveOrInactive = ({ status, userId }: any) => {
  const navigate = useNavigate();

  const [showDialog, setShowDialog] = useState(false);

  const { selectedUserFacilities, userFacilities } = useStoreWrapper(
    (state) => ({
      selectedUserFacilities: state.selectedUserFacilities,
      userFacilities: state.userFacilities,
    })
  );

  const handleShowDialog = () => {
    setShowDialog(!showDialog);
  };

  const { makeUserActiveInActive } = useUser();

  const { isLoading, mutate: changeStatus } = makeUserActiveInActive;

  const selectedUserFacilitiesNames = selectedUserFacilities.map(
    (facility: any) => facility.facilityName
  );

  let loggedInUserFacilitiesWithDeactivatePerm = userFacilities
    .map((facility: any) => {
      return {
        facilityName: facility.facilityName,
        userAdminFacilityPermissions:
          facility.permissions.accountAdminPermissions.filter(
            (value: any) => value.apiName === "deactivateUser"
          ),
      };
    })
    .filter(
      (facility: any) =>
        facility.userAdminFacilityPermissions[0].permissionValue
    )
    .map((facility: any) => facility.facilityName);

  const canDeactiveUserFacilities = selectedUserFacilitiesNames.filter(
    (facility: any) =>
      loggedInUserFacilitiesWithDeactivatePerm.includes(facility)
  );
  const canDeactivateUser = canDeactiveUserFacilities.length > 0;

  return (
    <Container>
      {canDeactivateUser && (
        <Button
          addClass="text-purple-light border-0 transparent"
          click={handleShowDialog}
        >
          {status === "Active" ? (
            <>
              <FaUserMinus size={20} className="relative top-1 mr-1.5" />
              Deactivate User
            </>
          ) : (
            <>
              <FaUserPlus size={20} className="relative top-1 mr-1.5" />
              Reactivate User
            </>
          )}
        </Button>
      )}

      {showDialog && (
        <AlertDialog
          message={
            status === "Active"
              ? "Do you want to Deactivate the user ?"
              : "Do you want to Reactivate the user ?"
          }
          onConfirm={() => {
            const data = {
              userId,
              status: status === "Active" ? "InActive" : "Active",
            };
            changeStatus(data, {
              onSuccess: (res: any) => {
                toast.success(res.data.message);
                navigate("/user/users");
              },
              onError: (error: any) => {
                // Close first: the dialog overlay sits above the toast.
                setShowDialog(false);
                toast.error(
                  error?.response?.data?.message ||
                    "Couldn't update this user's status. Please try again."
                );
              },
            });
          }}
          onCancel={() => setShowDialog(false)}
          loading={isLoading}
        />
      )}
    </Container>
  );
};

export default MakeUserActiveOrInactive;
